import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVector4 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 500,
	height: 300,
	viewBox: "-100 150 1347 1052",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		filter: "url(#filter0_df_3275_24492)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M366.127 205.417L49.581 312.286C22.2098 321.527 0.93827 343.345 -7.60497 370.942L-77.1347 595.54C-90.7149 639.408 -69.0905 686.465 -26.9576 704.73L294.08 843.905C330.485 859.688 372.932 849.766 398.569 819.481L492.11 708.982C511.36 686.242 540.616 674.503 570.245 677.629L851.578 707.313C879.564 710.266 907.32 699.958 926.595 679.455L1121.76 471.85C1162.27 428.766 1150.92 358.997 1098.86 330.962L1012.19 284.296C996.112 275.637 977.778 272.076 959.625 274.084L721.093 300.479C707.676 301.963 694.097 300.411 681.361 295.936L424.749 205.777C405.796 199.118 385.16 198.991 366.127 205.417Z",
			fill: "#F76323"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_df_3275_24492",
		x: -281.176,
		y: .687988,
		width: 1627.38,
		height: 1050.65,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 20 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 40 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_3275_24492"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_3275_24492",
				result: "shape"
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				stdDeviation: 100,
				result: "effect2_foregroundBlur_3275_24492"
			})
		]
	}) })]
});
export default SvgVector4;
